module.exports = __webpack_public_path__ + "svg/bg-triangle-alt.svg";